// extracted by mini-css-extract-plugin
module.exports = {"terminal":"terminal_terminal__3emu1","running":"terminal_running__3MpGa"};